import { useEffect } from 'react';
import { useSettings } from '../contexts/SettingsContext';
import { APP_BRAND } from '../config/branding';

/** Sync browser tab title with the configured application name. */
export function useDocumentTitle(pageTitle?: string | null): void {
  const { appConfig } = useSettings();
  const appName = appConfig.system.appName?.trim() || APP_BRAND.name;

  useEffect(() => {
    const trimmedPageTitle = pageTitle?.trim();
    document.title = trimmedPageTitle ? `${trimmedPageTitle} - ${appName}` : appName;
  }, [appName, pageTitle]);
}
